import React, {useContext, useState} from 'react';
import clsx from 'clsx';
import Select, {components, DropdownIndicatorProps, ClearIndicatorProps, MultiValueRemoveProps} from 'react-select';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import {Context} from '../../../Helpers/Auth';
import {IoMdCloseCircle} from 'react-icons/io';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';

function SelectComponentFilt({value, options, onChange, onInputChange, noOptionsMessage, placeholder, isDisabled, sort = true, isClearable = true, onMenuOpen}) {
    const sortedOptions = Array.isArray(options) ? (sort ? options.slice().sort((a, b) => a.value - b.value) : options.slice()) : [];

    const {theme} = useContext(Context);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const ClearIndicator = props => {
        const {
            children = <ClearRoundedIcon />,
            getStyles,
            innerProps: {ref, ...restInnerProps},
        } = props;
        return (
            <div {...restInnerProps} ref={ref} style={{cursor: 'pointer'}}>
                {children}
            </div>
        );
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: theme === 'dark' ? '#1f2937' : '#fff',
            borderColor: theme === 'dark' ? (state.isFocused ? '#555' : '#444') : state.isFocused ? '#aaa' : '#ddd',
            color: theme === 'dark' ? '#fff' : '#1f2937',
            minHeight: '20px',
            height: '22px',
        }),
        valueContainer: provided => ({
            ...provided,
            height: '20px',
            padding: '0 6px',
        }),
        input: provided => ({
            ...provided,
            margin: '0px',
            color: theme === 'dark' ? '#fff' : '#1f2937',
        }),
        indicatorSeparator: provided => ({
            ...provided,
            display: 'none',
        }),
        indicatorsContainer: provided => ({
            ...provided,
            height: '20px',
        }),
        menu: provided => ({
            ...provided,
            backgroundColor: theme === 'dark' ? '#222' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: theme === 'dark' ? (state.isSelected ? '#000' : state.isFocused ? '#111827' : '#1f2937') : state.isSelected ? '#ddd' : state.isFocused ? '#eee' : '#fff',
            color: theme === 'dark' ? '#fff' : '#1f2937',
        }),
        singleValue: provided => ({
            ...provided,
            color: theme === 'dark' ? '#fff' : '#1f2937',
        }),
        placeholder: provided => ({
            ...provided,
            color: theme === 'dark' ? '#aaa' : '#555',
        }),
    };

    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        if (onMenuOpen) {
            onMenuOpen();
        }
    };

    const handleMenuClose = () => {
        setIsMenuOpen(false);
    };
    // const handleClick = () => {
    //     onClick();
    // };
    const handleClear = () => {
        onChange(null);
    };

    return (
        // <ReactSelect
        //     value={value}
        //     options={sortedOptions}
        //     onChange={selectedOption => {
        //         onChange(selectedOption);
        //         handleMenuClose();
        //     }}
        //     noOptionsMessage={noOptionsMessage}
        //     placeholder={placeholder}
        //     onInputChange={onInputChange}
        //     isDisabled={isDisabled}
        //     onMenuOpen={handleMenuOpen}
        //     onMenuClose={handleMenuClose}
        //     menuIsOpen={isMenuOpen}
        //     isClearable={isClearable}
        //     // onClick={handleClick}
        // />
        <div className="w-full mt-2">
            <Select
                styles={customStyles}
                options={sortedOptions}
                value={value}
                onChange={selectedOption => {
                    onChange(selectedOption);
                    handleMenuClose();
                }}
                noOptionsMessage={() => noOptionsMessage}
                onInputChange={onInputChange}
                placeholder={placeholder}
                isDisabled={isDisabled}
                isSearchable={true}
                onMenuOpen={handleMenuOpen}
                onMenuClose={handleMenuClose}
                menuIsOpen={isMenuOpen}
                isClearable={isClearable}
                // components={{
                //     ClearIndicator: isClearable ? props => <ClearIndicator {...props} innerProps={{...props.innerProps, onMouseDown: handleClear}} /> : null,
                //     DropdownIndicator: props => (
                //         <components.DropdownIndicator {...props}>
                //             <KeyboardArrowDownOutlinedIcon />
                //         </components.DropdownIndicator>
                //     ),
                // }}
            />
        </div>
    );
}

export default SelectComponentFilt;
